import React, { useEffect, useRef, useState } from "react";
import { Box, Button, IconButton, Input, LinearProgress, Snackbar, TextField } from "@mui/material";
import { isEmpty } from "lodash";
import SendIcon from '@mui/icons-material/Send';
import SettingsIcon from '@mui/icons-material/Settings';
import TextEditorWithTitle from "../question/components/TextEditorWithTitle";
import { createMcqQuestion } from "../../services/question/mcq";
import { useParams } from "react-router-dom";
import QuestionViewPopup from "../questions/QuestionViewPopup";
import { docxToQuestions } from "../../components/wordProcessor/docxToLexical";
import ConfigurationView from "./components/ConfigurationView";
import { docxToQuestionsFromTable } from "../../components/wordProcessor/docxToLexicalFromTable";

function WordEditorSimpleTable() {

  const [answers, setAnswers] = useState([]);

  const [loading, setLoading] = useState(false);
  const [loadingQuestionOrAnswer, setLoadingQuestionOrAnswer] = useState(false);
  
  const [questionEditorState, setQuestionEditorState] = useState({})
  const [answerEditorStates, setAnswerEditorStates] = useState([])
  const [quesiton, setQuesiton] = useState("");

  const [questionNumber, setQuestionNumber] = useState(1)
  const [questionNumberPrefix, setQuestionNumberPrefix] = useState("")

  const [loadedFile, setLoadedFile] = useState(null)
  const [allQuestionParas, setAllQuestionParas] = useState([])

  const [questionView, setQuestionView] = useState({
    open: false,
    question: null,
  })

  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
  })

  const [showConfigView, setShowConfigView] = useState(false)
  const [configuration, setConfiguration] = useState({
    questionType: "normal"
  })

  const [currentQuestionObject, setCurrentQuestionObject] = useState(null)

  const inputRefs = useRef([]);

  const {subjectId_} = useParams()

  const [uploadedComplete, setUploadedComplete] = useState(false)
  const [wantToRemoveExtraSpaces, setWantToRemoveExtraSpaces] = useState(true)

  useEffect(() => {
      const currentQuestionObject_ = allQuestionParas.length >= questionNumber ? allQuestionParas[questionNumber - 1] : null;
      if(currentQuestionObject_){
  
        switch(configuration.questionType) {
          case "bio":{
            const newAnswerParas = [
              "(A), (B), (D) නිවැරදියි", "(A), (C), (D) නිවැරදියි", "(A), (B) නිවැරදියි", "(C), (D) නිවැරදියි", "වෙනත් ප්‍රතිචාර හෝ සංයෝජනයක් හෝ නිවැරදියි"
            ]
            let allAnswerParas = [];
            for(let i=0; i< currentQuestionObject_.answers.length; i++){
              for(let j=0; j< currentQuestionObject_.answers[i].length; j++){
                allAnswerParas.push(currentQuestionObject_.answers[i][j]);
              }
            }
  
            const newQuestionParas = [
              ...currentQuestionObject_.questionParas,
              ...allAnswerParas,
            ];
            setCurrentQuestionObject({
              ...currentQuestionObject_,
              questionParas: newQuestionParas,
              answers: [1,2,3,4,5],
              htmlAnswers: [...newAnswerParas]
            })
          }
            break;
          case "chem1":{
            const newAnswerParas = [
              "<p>පළමුවන වගන්තිය සත්‍යය</p><p>දෙවැනි වගන්තිය සත්‍ය වන අතර, පළමුවැන්න නිවැරදිව පහදා දෙයි</p>", 
              "<p>පළමුවන වගන්තිය සත්‍ය</p><p>දෙවැනි වගන්තිය සත්‍ය වන නමුත්, පළමුවැන්න ප්‍රකාශය නිවැරදිව පහදා නොදෙයි</p>",
              "<p>පළමුවන වගන්තිය සත්‍ය</p><p>දෙවැනි වගන්තිය අසත්‍යය වේ</p>",
              "<p>පළමුවන වගන්තිය අසත්‍ය</p><p>දෙවැනි වගන්තිය සත්‍ය වේ</p>",
              "<p>පළමුවන වගන්තිය අසත්‍ය</p><p>දෙවැනි වගන්තිය අසත්‍යය වේ</p>",
            ]
            let allAnswerParas = [];
            for(let i=0; i< currentQuestionObject_.answers.length; i++){
              for(let j=0; j< currentQuestionObject_.answers[i].length; j++){
                allAnswerParas.push(currentQuestionObject_.answers[i][j]);
              }
            }
  
            const newQuestionParas = [
              ...currentQuestionObject_.questionParas,
              ...allAnswerParas,
            ];
            setCurrentQuestionObject({
              ...currentQuestionObject_,
              questionParas: newQuestionParas,
              answers: [1,2,3,4,5],
              htmlAnswers: [...newAnswerParas]
            })
          }
            break;
          case "chem2":
            {
            const newAnswerParas = [
              "(a) සහ (b) පමණක් නිවැරදියි",
              "(b) සහ (c) පමණක් නිවැරදියි",
              "(c) සහ (d) පමණක් නිවැරදියි",
              "(d) සහ (a) පමණක් නිවැරදියි",
              "වෙනත් ප්‍රතිචාර සංඛ්‍යාවක් හෝ සංයෝජනයක් හෝ නිවැරදි"
            ]
            let allAnswerParas = [];
            for(let i=0; i< currentQuestionObject_.answers.length; i++){
              for(let j=0; j< currentQuestionObject_.answers[i].length; j++){
                allAnswerParas.push(currentQuestionObject_.answers[i][j]);
              }
            }
            
            const newQuestionParas = [
              ...currentQuestionObject_.questionParas,
              ...allAnswerParas,
            ];
            setCurrentQuestionObject({
              ...currentQuestionObject_,
              questionParas: newQuestionParas,
              answers: [1,2,3,4,5],
              htmlAnswers: [...newAnswerParas]
            })
          }
            break;
          case "normal":
          default:
            console.log("comesh here")
            setCurrentQuestionObject({...currentQuestionObject_});
            break;
        }
  
        
      }else{
        setCurrentQuestionObject(null);
      }
    }, [questionNumber, configuration, allQuestionParas])
  

  useEffect(() => {
    inputRefs.current = answers.map((_, i) => inputRefs.current[i] || React.createRef());
  }, [answers]);

  useEffect(() => {
    if(answers.length < 5){
      return;
    }
    const loadingQuestionOrAnswerToSystem = Object.values(loadingQuestionOrAnswer).some(v => v === true);
    if(uploadedComplete && !loadingQuestionOrAnswerToSystem && quesiton !== ""){
      setUploadedComplete(false);
      setTimeout(() => {
        addQuestion();
      }, 500);
    }
  }, [uploadedComplete, loadingQuestionOrAnswer, quesiton, answers])

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    const questions = await docxToQuestionsFromTable(file);
    setAllQuestionParas(questions);
    console.log("length", questions.length)
    setLoadedFile(file);
    setQuestionNumber(1);
    setQuestionNumberPrefix("")
  };


  const onChangeHtml = (html, index) => {
    if (index === -1) {
      console.log(html)
      setQuesiton(html);
    } else {
      setAnswers(
        prevAnswers =>{
          const newAnswers = [...prevAnswers];
          newAnswers[index] = html;
          return newAnswers;
        }
      )
    }
  };


  const handleChangeAnswerEditorState = (state, index) => {
    setAnswerEditorStates((prevStates) => {
      const newStates = [...prevStates];
      newStates[index] = state;
      return newStates;
    });
  }

  const handleNamePrefixChange = (e) => {
    const str = e.target.value
    //check / is present in the string
    if (str.includes("/")) {
      alert("Question name prefix cannot contain '/' character");
      return;
    }
    setQuestionNumberPrefix(e.target.value);
  }

  const handleNumberChange = (e) => {
    const str = e.target.value
    // check is number
    if (isNaN(str)) {
      alert("Question number must be a number");
      return;
    }
    onReset();
    setTimeout(() => {
      setQuestionNumber(str);
    }, 0);
  }


  const onReset = () => {
    setAnswers([]);
    setQuestionEditorState("");
    setAnswerEditorStates([]);
    setQuesiton("");
    setLoadingQuestionOrAnswer({});
    setCurrentQuestionObject(null);
  };

  const nextQuestion = () => {
    onReset();
    setTimeout(() => {
      setQuestionNumber(Number(questionNumber) + 1);
    }, 0); 
  }

  const addQuestion = async() => {
    const questionName = `${questionNumberPrefix}-${questionNumber}`;

    try{
      setLoading(true);

      if(questionNumberPrefix === "") {
        alert("Question name cannot be empty");
        return
      }

      // console.log(Number.isInteger(Number(questionNumber)))

      if(!Number.isInteger(Number(questionNumber))) {
        alert("Question number should be an integer");
        return
      }

      if(quesiton === "") {
        alert("Question cannot be empty");
        return
      }
      if(answers.length === 0) {
        alert("At least one answer is required");
        return
      }
      if(isEmpty(questionEditorState) || Object.keys(questionEditorState).length === 0) {
        alert("Question editor state cannot be empty");
        return
      }

      const currentQuestionObject_ = allQuestionParas.length >= questionNumber ? allQuestionParas[questionNumber - 1] : null;
      if(!currentQuestionObject_) {
        alert("No question found in the document for this question number");
        return
      }

      const mcqOptions = answers.map((answer, index) => ({
        answerText : answer,
        answerTextEditorState: answerEditorStates[index] || '',
        mark: currentQuestionObject_.correctAnswerIndexArray?.includes(index) ? 1.0 : 0.0,
      }))


      const questionBody = {
                question: {
                    name : questionName,
                    questionText: quesiton,
                    questionTextEditorState : questionEditorState,
                    generalFeedback: "",
                    generalFeedbackEditorState : "",
                    defaultMark: 4.0,
                    questionType: { id: 1 },
                    subjectTopics: [],
                    subject: { id: subjectId_ },
                    isReviewAvailable: false,
                    status : "PENDING",
                },
                "singleChoice": true,
                "shuffleChoices": false,
                "numberOfChoices": mcqOptions.length,
                "multiChoiceOptions": mcqOptions
            }

            // console.log(questionBody)

            setQuestionView({
              open: true,
              question: questionBody,
            })
            // const response = await createMcqQuestion(subjectId_, questionBody);
            // const { data, status } = response;
            // if (status === 200) {
            //   onReset();
            //   setQuestionNumber(Number(questionNumber) + 1);

            // }

    }catch(e) {
      console.error("Error adding question", e);
    }finally {
      setLoading(false);
    }
  }

  const setNextQuestionNumber = () => {
    const currentQuestionNumber = Number(questionNumber);
    if(currentQuestionNumber < 9){
      const nextNumber = Number(questionNumber) + 1;
      setQuestionNumber('0' + nextNumber);
    }else{
      setQuestionNumber(Number(questionNumber) + 1);
    }
  }

  const onAfterOkay = async() => {
    let questionName = `${questionNumberPrefix}-${questionNumber}`;
    if(Number(questionNumber) < 10){
      questionName = `${questionNumberPrefix}-0${Number(questionNumber)}`;
    }

    try{
      setLoading(true);

      if(quesiton === "") {
        alert("Question cannot be empty");
        return
      }
      if(isEmpty(questionEditorState) || Object.keys(questionEditorState).length === 0) {
        alert("Question editor state cannot be empty");
        return
      }

      const currentQuestionObject_ = allQuestionParas.length >= questionNumber ? allQuestionParas[questionNumber - 1] : null;

      const mcqOptions = answers.map((answer, index) => ({
        answerText : answer,
        answerTextEditorState: answerEditorStates[index] || {},
        mark: currentQuestionObject_.correctAnswerIndexArray?.includes(index) ? 1.0 : 0.0,
      }))

      const questionBody = {
                question: {
                    name : questionName,
                    questionText: quesiton,
                    questionTextEditorState : questionEditorState,
                    generalFeedback: "",
                    generalFeedbackEditorState : "",
                    defaultMark: 4.0,
                    questionType: { id: 1 },
                    subjectTopics: [],
                    subject: { id: subjectId_ },
                    isReviewAvailable: false,
                    status : "PENDING",
                },
                "singleChoice": true,
                "shuffleChoices": false,
                "numberOfChoices": mcqOptions.length,
                "multiChoiceOptions": mcqOptions
            }

            // console.log(questionBody)

            // setQuestionView({
            //   open: true,
            //   question: questionBody,
            // })
            const response = await createMcqQuestion(subjectId_, questionBody);
            const { data, status } = response;
            if (status === 200) {
              onReset();
              setTimeout(() => {
                setNextQuestionNumber();
                setTimeout(() => {
                  setUploadedComplete(true);
                }, 0);
              }, 0);
              setSnackOpen({ open: true, message: "Question created successfully" });
            }else{
              setSnackOpen({ open: true, message: "Error creating question" });
              alert("Error creating question");
            }

    }catch(e) {
      console.error("Error adding question", e);
      setSnackOpen({ open: true, message: "Error creating question" });
      alert("Error creating question");
    }finally {
      setLoading(false);
      setQuestionView({ open: false, question: null });
    }
  }

  const setLoadingQuestion = (value) => {
    setLoadingQuestionOrAnswer(prev => ({...prev, question: value}));
  }

  const setLoadingAnswer = (value, index) => {
      setLoadingQuestionOrAnswer(prev => ({...prev, [index]: value}));
  }

  const loadingQuestionOrAnswerToSystem = Object.values(loadingQuestionOrAnswer).some(v => v === true);
  const loadingFinal = loading || loadingQuestionOrAnswerToSystem;

  // const currentQuestionObject = allQuestionParas.length >= questionNumber ? allQuestionParas[questionNumber - 1] : null;

  console.log("geeeeeeeeeeeee" , currentQuestionObject)

  return (
    <>
      <div
        style={
          {
            // height: "300px",
          }
        }
      >
        <div
          style={{
            position: "fixed",
            bottom: "0px",
            zIndex: 1000,
            backgroundColor: "wheat",
            padding: "12px",
            // height: "100px",
            width: "100%",
          }}
        >
          <input type="file" onChange={handleFileUpload} />

          <button onClick={onReset} style={{ marginTop: "1rem" }}>
            Reset
          </button>

          <TextField
            type="text"
            value={questionNumberPrefix}
            placeholder="Question name prefix"
            onChange={handleNamePrefixChange}
            style={{
              width: "150px",
              backgroundColor: "#f0f0f0",
            }}
          />

          <TextField
            type="text"
            value={questionNumber}
            placeholder="Number"
            onChange={handleNumberChange}
            style={{
              width: "100px",
              backgroundColor: "#f0f0f0",
            }}
          />

          <Button
            onClick={nextQuestion}
            style={{ marginTop: "1rem", left: "1rem", marginRight: "1rem" }}
            variant="outlined"
            endIcon={<SendIcon />}
            disabled={loadingFinal}
          >
            Next Question
          </Button>

          <Button
            onClick={addQuestion}
            style={{ marginTop: "1rem", left: "1rem", marginRight: "5rem" }}
            variant="contained"
            color="success"
            disabled={loadingFinal}
          >
            Add question
          </Button>

            <IconButton color="primary" aria-label="add to shopping cart" onClick={() => setShowConfigView(true)}>
              <SettingsIcon />
            </IconButton>
        </div>

        {loadingFinal ? (
          <Box
            sx={{ width: "100%", top: "10px", position: "sticky", zIndex: 100 }}
          >
            <LinearProgress />
          </Box>
        ) : null}

        <div
          style={{
            height: "10%",
            width: "100%",
            overflowY: "auto",
            marginTop: "1rem",
            border: "1px solid #ccc",
            padding: "1rem",
            bottom: "100px",
            marginBottom: "100px",
          }}
        >
          {currentQuestionObject ? (<TextEditorWithTitle
            title={"Question"}
            setLoading={setLoadingQuestion}
            loading={loading}
            editorState={{}}
            // html={coppiedQuestionContent}
            onChangeEditorState={setQuestionEditorState}
            onChangeHtml={(html) => onChangeHtml(html, -1)}
            currentHtml={quesiton}
             key={questionNumber + "-question"}
            questionNumberIndex={questionNumber - 1}
            loadedFile={loadedFile}
            wantToRemoveExtraSpaces={wantToRemoveExtraSpaces}
            currentParas={currentQuestionObject?.questionParas}
          />) : (<div>No question found in the document for this question number</div>)}

          {currentQuestionObject?.answers.map((answer, index) => (
            <Box
              style={{
                display: "flex", 
                alignItems: "center",
                justifyContent: "flex-start",
                marginTop: "1rem",
              }}
              key={index + 1}
            >
              <TextEditorWithTitle
                title={`Answer ${index + 1}`}
                setLoading={(loading) => setLoadingAnswer(loading, index)}
                loading={loading}
                editorState={{}}
                onChangeEditorState={(state) =>
                  handleChangeAnswerEditorState(state, index)
                }
                onChangeHtml={(html) => onChangeHtml(html, index)}
                currentHtml={answers[index] || ""}
                index={index}
                key={questionNumber + "-" + index}
                questionNumberIndex={questionNumber - 1}
                loadedFile={loadedFile}
                wantToRemoveExtraSpaces={wantToRemoveExtraSpaces}
                currentParas={currentQuestionObject?.answers ? currentQuestionObject?.answers[index] : null}
                html={currentQuestionObject?.htmlAnswers ? currentQuestionObject.htmlAnswers[index] : null}
              />
              {/* </div> */}
              {/* <div
                style={{
                  width: "100px",
                  backgroundColor: "#c91f1fff",
                }}
              >
                <Button
                  variant="outlined"
                  startIcon={<DeleteIcon />}
                  onClick={() => {
                    handleDeleteAnswer(index);
                  }}
                >
                  Delete
                </Button>
              </div> */}
            </Box>
          ))}
        </div>
      </div>

      <QuestionViewPopup
        questionView={questionView}
        setQuestionView={setQuestionView}
        justView={true}
        onAfterOkay={onAfterOkay}
        onAfterCancel={() => setQuestionView({ open: false, question: null })}
      />

      <Snackbar
        open={snackOpen.open}
        autoHideDuration={3000}
        onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        message={snackOpen.message}
      />

      <ConfigurationView
        open={showConfigView}
        setOpen={setShowConfigView}
        configuration={configuration}
        setConfiguration={setConfiguration}
      />
    </>
  );
}

export default WordEditorSimpleTable